<div style="width: 90px; cursor: pointer;" (click)="goToHome()">
  <svg
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 1080 556.89"
    style="enable-background: new 0 0 1080 556.89"
    xml:space="preserve"
  >
    <g>
      <path
        class="st0"
        d="M255.14,175.05c0,5.29-4.23,9.7-9.7,9.7c-5.47,0-9.7-4.23-9.7-9.7c0-5.29,4.23-9.69,9.7-9.69
C250.91,165.36,255.14,169.77,255.14,175.05"
      />
      <path
        class="st0"
        d="M125.34,230.24c0,5.29-4.23,9.7-9.7,9.7c-5.47,0-9.7-4.23-9.7-9.7c0-5.29,4.23-9.7,9.7-9.7
C121.11,220.54,125.34,224.95,125.34,230.24"
      />
      <path
        class="st0"
        d="M121.44,307.23c0,5.29-4.23,9.7-9.7,9.7c-5.47,0-9.7-4.23-9.7-9.7c0-5.29,4.23-9.7,9.7-9.7
C117.2,297.53,121.44,301.95,121.44,307.23"
      />
      <path
        class="st0"
        d="M39.79,246.56c0,5.29-4.23,9.7-9.7,9.7c-5.47,0-9.7-4.23-9.7-9.7c0-5.29,4.23-9.7,9.7-9.7
C35.56,236.86,39.79,241.27,39.79,246.56"
      />
      <path
        class="st0"
        d="M131.14,183.17c0,5.29-4.23,9.7-9.7,9.7c-5.3,0-9.7-4.23-9.7-9.7c0-5.29,4.23-9.7,9.7-9.7
C126.73,173.47,131.14,177.88,131.14,183.17"
      />
      <path
        class="st0"
        d="M174.26,136.67c0,5.29-4.23,9.7-9.7,9.7c-5.47,0-9.7-4.24-9.7-9.7c0-5.29,4.23-9.7,9.7-9.7
C170.03,126.97,174.26,131.38,174.26,136.67"
      />
      <path
        class="st0"
        d="M316.63,101.24c0,5.29-4.23,9.7-9.7,9.7c-5.47,0-9.7-4.23-9.7-9.7c0-5.29,4.23-9.69,9.7-9.69
C312.4,91.55,316.63,95.95,316.63,101.24"
      />
      <path
        class="st0"
        d="M370.89,144.75c0,5.29-4.23,9.7-9.7,9.7c-5.47,0-9.7-4.24-9.7-9.7c0-5.29,4.23-9.7,9.7-9.7
C366.65,135.05,370.89,139.46,370.89,144.75"
      />
      <path
        class="st0"
        d="M486.98,216.86c0,5.29-4.23,9.7-9.7,9.7c-5.3,0-9.7-4.24-9.7-9.7c0-5.29,4.23-9.7,9.7-9.7
C482.75,207.16,486.98,211.57,486.98,216.86"
      />
      <path
        class="st0"
        d="M390.61,228.65c0,5.29-4.23,9.7-9.7,9.7c-5.3,0-9.7-4.23-9.7-9.7c0-5.29,4.23-9.7,9.7-9.7
C386.2,218.95,390.61,223.36,390.61,228.65"
      />
      <path
        class="st0"
        d="M404.7,289.05c0,5.29-4.23,9.7-9.7,9.7c-5.3,0-9.7-4.23-9.7-9.7c0-5.29,4.23-9.69,9.7-9.69
C400.3,279.36,404.7,283.76,404.7,289.05"
      />
      <path
        class="st1"
        d="M185.45,191.65v11.04c1.41-0.29,2.55-0.85,3.4-1.98c0.85-1.14,1.42-2.26,1.42-3.68c0-1.13-0.29-2.26-1.13-3.11
C188.56,192.78,187.15,191.93,185.45,191.65 M183.46,151.24c-20.7,0-37.58,16.88-37.58,37.58c0,20.69,16.88,37.58,37.58,37.58
s37.58-16.88,37.58-37.58C221.03,168.12,204.15,151.24,183.46,151.24 M194.23,204.39c-1.98,2.26-4.81,3.68-8.49,4.25v5.38h-4.25
v-5.1c-3.12-0.29-5.94-1.7-7.93-3.68c-1.98-1.99-3.4-4.82-3.97-8.49l7.36-0.85c0.29,1.41,0.85,2.83,1.7,3.96
c0.85,1.13,1.7,1.98,2.83,2.26v-11.89c-3.68-1.13-6.23-2.55-8.21-4.81c-1.7-2.27-2.55-4.82-2.55-7.64c0-3.12,0.85-5.67,2.83-7.65
c1.98-1.98,4.53-3.39,7.64-3.68v-2.83h3.96v2.83c3.12,0.29,5.38,1.41,7.08,3.11c1.7,1.7,2.83,3.97,3.4,6.79l-7.08,0.85
c-0.56-2.26-1.41-3.68-3.4-4.53v11.04c4.53,1.13,7.65,2.83,9.06,4.81c1.7,1.98,2.55,4.53,2.55,7.36
C197.34,199.29,196.21,202.12,194.23,204.39 M177.8,177.49c0,1.14,0.29,1.99,0.85,2.83c0.56,0.85,1.41,1.41,2.83,1.98v-9.62
c-1.13,0.28-1.98,1.13-2.55,1.98C178.09,175.51,177.8,176.36,177.8,177.49"
      />
      <path
        class="st2"
        d="M348.25,281.83v9.85c1.23-0.21,2.26-0.82,3.08-1.85c0.82-1.03,1.23-2.05,1.23-3.28c0-1.03-0.41-2.05-1.03-2.88
C350.92,282.85,349.89,282.24,348.25,281.83 M346.4,246.56c-18.11,0-32.79,14.68-32.79,32.79c0,18.11,14.68,32.79,32.79,32.79
c18.11,0,32.79-14.68,32.79-32.79C379.19,261.24,364.51,246.56,346.4,246.56 M356.05,293.32c-1.85,2.05-4.52,3.29-7.8,3.9v4.72
h-3.69v-4.52c-2.87-0.41-5.34-1.43-7.18-3.28c-1.85-1.85-3.08-4.31-3.49-7.8l6.56-0.62c0.21,1.43,0.82,2.46,1.43,3.49
c0.82,1.03,1.64,1.64,2.46,2.05V280.6c-3.28-1.03-5.74-2.46-7.18-4.31c-1.64-1.85-2.26-4.31-2.26-6.98c0-2.66,0.82-5.13,2.67-6.97
c1.85-1.85,4.11-2.88,6.98-3.29v-2.46h3.69v2.46c2.67,0.41,4.72,1.23,6.36,2.67c1.64,1.44,2.67,3.49,3.08,6.16l-6.36,0.82
c-0.41-2.05-1.44-3.29-3.08-4.11v9.86c4.11,1.02,6.77,2.46,8.21,4.31c1.43,1.85,2.26,3.9,2.26,6.77
C358.72,288.8,357.9,291.27,356.05,293.32 M341.27,269.1c0,0.82,0.2,1.65,0.82,2.46c0.61,0.82,1.43,1.43,2.46,1.85v-8.83
c-1.03,0.41-1.85,0.82-2.46,1.65C341.68,267.25,341.27,268.08,341.27,269.1"
      />
      <path
        class="st3"
        d="M309.09,168.87v12.08c1.51-0.22,2.81-1.08,3.88-2.17c0.86-1.07,1.51-2.58,1.51-4.09c0-1.3-0.43-2.59-1.29-3.67
C312.32,170.38,311.03,169.52,309.09,168.87 M306.93,124.96c-22.6,0-41.1,18.29-41.1,41.09c0,22.61,18.29,41.1,41.1,41.1
c22.6,0,41.1-18.29,41.1-41.1C348.03,143.25,329.53,124.96,306.93,124.96 M318.58,183.1c-2.16,2.59-5.39,4.1-9.5,4.75v5.83h-4.52
v-5.61c-3.67-0.43-6.47-1.72-8.63-4.1c-2.16-2.16-3.66-5.39-4.31-9.49l7.98-0.86c0.43,1.73,0.86,3.01,1.94,4.31
c0.86,1.3,1.94,2.16,3.02,2.59v-12.95c-4.1-1.08-6.91-2.8-8.85-5.17c-1.94-2.38-2.81-5.18-2.81-8.63c0-3.45,1.08-6.26,3.24-8.62
c2.16-2.38,4.96-3.67,8.63-3.89v-3.02h4.52v3.02c3.24,0.43,5.83,1.51,7.77,3.44c1.94,1.94,3.24,4.32,3.67,7.34l-7.77,1.08
c-0.43-2.38-1.73-4.1-3.67-4.96v12.07c4.96,1.3,8.42,3.03,10.14,5.18c1.73,2.15,2.59,4.96,2.59,8.19
C322.03,177.5,320.96,180.52,318.58,183.1 M300.68,153.55c0,1.08,0.43,2.16,1.08,3.02c0.65,0.86,1.73,1.73,3.02,2.38v-10.79
c-1.29,0.43-2.16,1.07-2.81,2.15C301.11,151.18,300.68,152.26,300.68,153.55"
      />
      <path
        class="st1"
        d="M119.65,132.47v11.05c1.38-0.23,2.53-0.92,3.45-1.84c0.92-1.15,1.38-2.3,1.38-3.68c0-1.15-0.46-2.3-1.15-3.22
C122.42,133.62,121.26,132.93,119.65,132.47 M117.6,96.94c-18.13,0-32.79,14.66-32.79,32.79c0,18.13,14.65,32.79,32.79,32.79
c18.13,0,32.79-14.66,32.79-32.79C150.39,111.6,135.73,96.94,117.6,96.94 M128.17,145.36c-2.07,2.3-4.83,3.68-8.51,4.37v5.29h-4.14
v-5.06c-3.22-0.46-5.76-1.61-7.82-3.68c-2.07-2.07-3.22-4.83-3.91-8.51l7.36-0.69c0.23,1.61,0.92,2.76,1.61,3.91
c0.92,1.15,1.84,1.84,2.76,2.3v-11.74c-3.68-1.15-6.45-2.53-8.05-4.83c-1.61-2.07-2.53-4.6-2.53-7.82c0-2.99,0.93-5.75,2.99-7.82
c1.84-2.07,4.6-3.23,7.82-3.68v-2.76h4.14v2.76c2.99,0.45,5.29,1.38,7.14,2.99c1.84,1.61,2.99,3.91,3.45,6.68l-7.14,0.92
c-0.46-2.3-1.61-3.68-3.45-4.6v11.04c4.6,1.16,7.59,2.76,9.2,4.84c1.62,1.84,2.53,4.37,2.53,7.37
C131.16,140.06,130.24,143.05,128.17,145.36 M111.83,118.43c0,0.92,0.23,1.85,0.92,2.77c0.69,0.92,1.61,1.61,2.76,2.07v-9.66
c-1.15,0.46-2.07,0.92-2.53,1.84C112.29,116.36,111.83,117.29,111.83,118.43"
      />
      <path
        class="st1"
        d="M375.43,93.5v11.04c1.38-0.23,2.53-0.92,3.45-1.84c0.92-1.16,1.38-2.3,1.38-3.68c0-1.15-0.46-2.3-1.15-3.22
C378.2,94.65,377.04,93.96,375.43,93.5 M373.37,56.21c-19.09,0-34.53,15.44-34.53,34.54c0,19.1,15.44,34.53,34.53,34.53
c19.1,0,34.54-15.44,34.54-34.53C407.91,71.65,392.47,56.21,373.37,56.21 M383.95,106.39c-2.07,2.3-4.83,3.68-8.51,4.37v5.29h-4.14
v-5.06c-3.22-0.46-5.75-1.61-7.82-3.68c-2.07-2.07-3.22-4.83-3.91-8.51l7.36-0.69c0.23,1.61,0.92,2.76,1.61,3.91
c0.92,1.15,1.84,1.84,2.76,2.3V92.58c-3.68-1.15-6.45-2.53-8.05-4.83c-1.61-2.07-2.53-4.6-2.53-7.82c0-2.99,0.93-5.75,2.99-7.82
c1.84-2.07,4.6-3.23,7.82-3.68v-2.76h4.14v2.76c2.99,0.46,5.29,1.39,7.14,2.99c1.84,1.61,2.99,3.91,3.45,6.68L379.12,79
c-0.46-2.3-1.61-3.68-3.45-4.6v11.04c4.6,1.16,7.59,2.76,9.2,4.84c1.62,1.84,2.53,4.37,2.53,7.36
C386.94,101.09,386.02,104.08,383.95,106.39 M367.61,79.46c0,0.92,0.23,1.85,0.92,2.76c0.69,0.92,1.61,1.61,2.76,2.07v-9.66
c-1.15,0.46-2.07,0.92-2.53,1.84C368.07,77.4,367.61,78.32,367.61,79.46"
      />
      <path
        class="st3"
        d="M447.27,266.19v11.08c1.32-0.26,2.64-0.79,3.43-1.85c0.79-1.05,1.32-2.38,1.32-3.69
c0-1.32-0.26-2.38-1.05-3.17C450.17,267.5,448.85,266.71,447.27,266.19 M445.14,226.58c-20.34,0-36.96,16.62-36.96,36.96
c0,20.35,16.62,36.96,36.96,36.96c20.34,0,36.96-16.62,36.96-36.96C482.1,242.95,465.48,226.58,445.14,226.58 M455.97,279.11
c-2.11,2.37-5.01,3.69-8.71,4.22v5.28h-4.22v-5.01c-3.17-0.52-5.81-1.58-7.91-3.7c-2.12-2.11-3.43-5.01-3.96-8.7l7.39-0.79
c0.26,1.58,0.79,2.9,1.59,3.96c0.79,1.05,1.84,1.85,2.64,2.38v-11.88c-3.7-1.06-6.33-2.64-8.18-4.75
c-1.85-2.12-2.64-4.75-2.64-7.65c0-3.17,1.05-5.81,2.9-7.65c1.84-2.11,4.48-3.43,7.65-3.69v-2.9h4.22v2.9
c2.9,0.27,5.28,1.32,7.13,3.17c1.84,1.58,2.9,3.95,3.42,6.86l-7.12,1.06c-0.53-2.11-1.58-3.69-3.43-4.49v11.08
c4.49,1.32,7.66,2.9,9.24,4.75c1.58,1.85,2.37,4.49,2.37,7.39C458.88,273.84,457.82,276.74,455.97,279.11 M439.62,252.2
c0,1.05,0.26,1.85,0.79,2.91c0.53,0.79,1.58,1.58,2.64,2.11v-9.77c-1.06,0.27-2.11,1.06-2.64,1.85
C439.88,250.09,439.62,250.88,439.62,252.2"
      />
      <path
        class="st1"
        d="M75.16,276.24v9.98c1.19-0.24,2.37-0.72,3.09-1.66c0.71-0.96,1.18-2.14,1.18-3.33c0-1.19-0.24-2.14-0.95-2.85
C77.78,277.43,76.59,276.72,75.16,276.24 M73.25,240.49c-18.37,0-33.38,15.01-33.38,33.38c0,18.36,15.01,33.37,33.38,33.37
s33.37-15.01,33.37-33.37C106.62,255.27,91.62,240.49,73.25,240.49 M83,287.87c-1.9,2.14-4.51,3.33-7.84,3.8v4.75h-3.8v-4.51
c-2.85-0.48-5.22-1.43-7.12-3.33c-1.9-1.9-3.08-4.51-3.56-7.84l6.65-0.71c0.24,1.43,0.71,2.61,1.42,3.56
c0.72,0.96,1.66,1.66,2.37,2.14v-10.69c-3.32-0.94-5.69-2.37-7.36-4.27c-1.66-1.9-2.37-4.28-2.37-6.89c0-2.85,0.95-5.22,2.61-6.88
c1.66-1.9,4.04-3.09,6.88-3.33v-2.61h3.8v2.61c2.61,0.23,4.75,1.19,6.41,2.85c1.66,1.42,2.61,3.56,3.09,6.17l-6.41,0.95
c-0.48-1.9-1.43-3.32-3.09-4.03v9.97c4.04,1.19,6.88,2.61,8.31,4.28c1.43,1.66,2.14,4.04,2.14,6.65
C85.61,283.13,84.66,285.74,83,287.87 M68.28,263.66c0,0.95,0.24,1.67,0.71,2.61c0.48,0.72,1.43,1.43,2.37,1.9v-8.79
c-0.95,0.24-1.89,0.95-2.37,1.66C68.52,261.76,68.28,262.47,68.28,263.66"
      />
      <path
        class="st2"
        d="M219.91,87.38v17.31c2.19-0.44,3.95-1.53,5.48-3.07c1.32-1.53,2.19-3.5,2.19-5.69c0-1.97-0.66-3.73-1.75-5.04
C224.3,89.35,222.54,88.25,219.91,87.38 M216.4,21.41c-33.96,0-61.58,27.61-61.58,61.8c0,34.19,27.61,61.8,61.8,61.8
s61.8-27.61,61.8-61.8C278.2,49.02,250.6,21.41,216.4,21.41 M233.28,107.76c-3.29,3.72-7.66,5.91-13.58,6.78v8.33h-6.36v-8.11
c-5.05-0.65-9.21-2.63-12.5-5.7c-3.29-3.06-5.26-7.66-6.13-13.58l11.61-1.32c0.44,2.41,1.32,4.38,2.63,6.13
c1.32,1.75,2.85,2.86,4.39,3.73V85.4c-5.7-1.75-10.09-4.16-12.71-7.45c-2.63-3.29-4.17-7.45-4.17-12.27
c0-4.82,1.54-8.99,4.61-12.27c3.06-3.29,7.23-5.26,12.27-5.7v-4.38h6.36v4.38c4.6,0.66,8.54,2.19,11.17,4.82
c2.85,2.63,4.6,6.14,5.26,10.52l-11.18,1.54c-0.65-3.51-2.41-5.92-5.26-7.02v17.31c7.01,1.97,11.83,4.38,14.46,7.45
c2.63,3.07,3.95,7.01,3.95,11.84C238.1,99.65,236.57,104.03,233.28,107.76 M207.64,65.24c0,1.54,0.44,3.07,1.32,4.39
c0.88,1.32,2.41,2.41,4.39,3.28V57.57c-1.75,0.66-3.07,1.54-4.17,3.07C208.08,61.96,207.64,63.49,207.64,65.24"
      />
      <path
        class="st2"
        d="M425.03,171.36v14.11c1.87-0.42,3.32-1.25,4.36-2.49c1.04-1.24,1.66-2.9,1.66-4.77c0-1.67-0.42-3.11-1.45-4.15
C428.77,172.8,427.32,171.98,425.03,171.36 M422.34,117.21c-28,0-50.61,22.62-50.61,50.62s22.61,50.61,50.61,50.61
c28,0,50.61-22.61,50.61-50.61S450.34,117.21,422.34,117.21 M436.03,188.15c-2.7,3.11-6.43,4.78-11,5.6v6.84h-5.19v-6.84
c-4.15-0.42-7.67-2.07-10.16-4.78c-2.69-2.7-4.36-6.22-4.98-11.2l9.54-1.04c0.41,1.87,1.04,3.53,2.28,4.98
c1.04,1.45,2.28,2.49,3.52,3.12v-15.36c-4.77-1.44-8.3-3.32-10.37-6.22c-2.28-2.7-3.32-6.02-3.32-9.96c0-3.95,1.25-7.26,3.74-9.96
c2.49-2.69,5.81-4.35,9.95-4.77v-3.53h5.19v3.53c3.94,0.42,6.85,1.87,9.13,3.94c2.28,2.07,3.74,4.98,4.36,8.71l-9.13,1.25
c-0.62-2.91-2.07-4.78-4.36-5.81v14.31c5.81,1.66,9.75,3.53,11.83,6.22c2.07,2.49,3.11,5.81,3.11,9.75
C440.18,181.31,438.72,185.04,436.03,188.15 M415.08,153.1c0,1.25,0.42,2.49,1.25,3.52c0.83,1.04,1.87,2.08,3.52,2.7v-12.65
c-1.45,0.42-2.49,1.25-3.31,2.49C415.5,150.4,415.08,151.65,415.08,153.1"
      />
      <path
        class="st2"
        d="M49.61,187.62v16.22c2.14-0.47,3.81-1.42,5.01-2.86c1.2-1.43,1.91-3.34,1.91-5.49c0-1.91-0.48-3.34-1.67-4.78
C53.91,189.29,52.24,188.33,49.61,187.62 M46.49,137.07C20.83,137.07,0,157.91,0,183.56s20.83,46.68,46.68,46.68
c25.85,0,46.68-20.84,46.68-46.68C93.36,157.71,72.33,137.07,46.49,137.07 M62.25,206.71c-3.1,3.34-7.16,5.49-12.64,6.2v7.63h-5.97
v-7.63c-4.77-0.48-8.59-2.39-11.69-5.25c-2.87-3.11-4.78-7.16-5.73-12.65l10.73-1.19c0.48,2.14,1.2,4.06,2.39,5.72
c1.19,1.68,2.62,2.87,4.06,3.58v-17.41c-5.49-1.43-9.31-3.82-11.93-6.92c-2.62-3.11-3.81-6.92-3.81-11.45
c0-4.54,1.43-8.35,4.3-11.45c2.86-3.11,6.68-4.78,11.45-5.25v-4.06h5.96v4.06c4.3,0.47,7.87,1.91,10.5,4.53
c2.62,2.39,4.3,5.73,5.01,10.02l-10.5,1.43c-0.72-3.34-2.39-5.49-5.01-6.68v16.23c6.68,1.91,11.21,4.05,13.6,6.92
c2.39,2.86,3.58,6.44,3.58,10.97C66.79,199.07,65.36,203.12,62.25,206.71 M38.4,166.86c0,1.43,0.48,2.87,1.43,4.06
c0.95,1.19,2.14,2.39,4.05,3.1v-14.31c-1.67,0.48-2.86,1.43-3.81,2.86C38.88,164,38.4,165.43,38.4,166.86"
      />
      <path
        class="st2"
        d="M159.78,291.32v9.85c1.23-0.21,2.26-0.82,3.08-1.85c0.82-1.02,1.23-2.05,1.23-3.28c0-1.23-0.41-2.05-1.03-2.87
C162.45,292.55,161.22,291.73,159.78,291.32 M157.91,256.06c-18.22,0-33,14.77-33,32.99c0,18.23,14.77,33,33,33
c18.22,0,33-14.77,33-33C190.72,270.83,175.95,256.06,157.91,256.06 M167.37,303.02c-1.84,2.06-4.51,3.29-7.8,3.9v4.72h-3.7v-4.51
c-2.87-0.41-5.33-1.44-7.18-3.29c-1.84-1.85-3.08-4.31-3.49-7.8l6.57-0.62c0.2,1.44,0.82,2.46,1.43,3.49
c0.82,1.02,1.64,1.63,2.46,2.05v-10.67c-3.29-1.02-5.75-2.46-7.18-4.31c-1.64-1.85-2.26-4.31-2.26-6.97c0-2.67,0.81-5.14,2.67-6.98
c1.64-1.85,4.1-2.87,6.98-3.28v-2.46h3.7v2.46c2.67,0.41,4.72,1.23,6.36,2.67c1.64,1.43,2.67,3.49,3.08,6.15l-6.36,0.82
c-0.41-2.05-1.43-3.28-3.08-4.1v9.85c4.11,1.02,6.77,2.46,8.21,4.31c1.44,1.85,2.26,3.9,2.26,6.77
C170.25,298.3,169.22,300.96,167.37,303.02 M152.8,278.8c0,0.82,0.21,1.65,0.82,2.46c0.61,0.82,1.43,1.44,2.46,1.85v-8.82
c-1.03,0.41-1.85,0.82-2.46,1.64C153.21,276.96,152.8,277.78,152.8,278.8"
      />
      <path
        class="st1"
        d="M313.76,39.48v10.83c1.51-0.25,2.52-1.01,3.53-2.01c0.75-1.01,1.26-2.27,1.26-3.78c0-1.26-0.25-2.27-1.01-3.28
C316.53,40.49,315.27,39.98,313.76,39.48 M311.54,0c-20.24,0-36.71,16.47-36.71,36.71c0,20.23,16.48,36.71,36.71,36.71
c20.24,0,36.71-16.47,36.71-36.71C348.25,16.47,331.78,0,311.54,0 M322.33,52.33c-2.02,2.27-4.79,3.78-8.57,4.28v5.3h-4.03v-5.04
c-3.28-0.5-5.8-1.51-7.81-3.52c-2.02-2.02-3.28-4.79-3.78-8.57l7.31-0.76c0.25,1.52,0.75,2.78,1.76,3.78
c0.76,1.01,1.76,1.77,2.77,2.27V38.22c-3.78-1.01-6.3-2.52-8.06-4.79c-1.77-2.01-2.52-4.79-2.52-7.81s1.01-5.54,3.02-7.81
c2.02-2.02,4.54-3.28,7.81-3.53v-2.77h4.04v2.77c3.02,0.25,5.29,1.26,7.05,3.02c1.76,1.77,2.77,4.03,3.28,6.81l-7.06,1
c-0.5-2.26-1.51-3.78-3.27-4.53v11.09c4.53,1.26,7.55,2.77,9.32,4.78c1.51,2.02,2.52,4.54,2.52,7.56
C325.35,47.04,324.34,50.06,322.33,52.33 M305.95,25.37c0,1.01,0.25,2.02,1.01,2.77c0.5,0.75,1.51,1.51,2.77,2.01v-9.82
c-1.01,0.25-2.02,1-2.52,2.01C306.2,23.35,305.95,24.36,305.95,25.37"
      />
      <path
        class="st0"
        d="M368.55,187.93c-79.8,42.81-107.46,102.91-115.74,126.72c-28.32-42.93-73.68-82.39-146.16-114.2
c76.18,59.43,193.12,110.4,126.28,356.43h64.02c1.78-56.6,4.79-120.48-15.04-181.47C266.32,270.46,368.55,187.93,368.55,187.93"
      />
      <path
        class="st0"
        d="M278.42,236.78c0,18.16-14.81,32.98-32.98,32.98c-18.16,0-32.97-14.82-32.97-32.98
c0-18.16,14.81-32.98,32.97-32.98C263.61,203.8,278.42,218.62,278.42,236.78"
      />
      <path
        class="st1"
        d="M695,352.66c0-3.88,1.41-7.23,4.06-10.05c2.82-2.82,5.99-4.06,10.05-4.06c3.88,0,7.23,1.41,10.05,4.06
c2.82,2.82,4.06,6,4.06,10.05c0,3.88-1.41,7.23-4.06,10.05c-2.82,2.82-5.99,4.06-10.05,4.06c-3.88,0-7.23-1.41-10.05-4.06
C696.23,359.89,695,356.71,695,352.66"
      />
      <path
        class="st0"
        d="M454.43,390.22c10.94,0,21.52,2.29,31.39,6.7c10.05,4.41,18.7,10.41,26.28,17.99
c7.59,7.58,13.58,16.41,17.99,26.45c4.41,10.06,6.7,20.81,6.7,32.28v72.49c0,2.99-1.06,5.47-3.17,7.58
c-2.12,2.12-4.59,3.17-7.58,3.17c-3,0-5.47-1.06-7.59-3.17c-2.12-2.11-3.17-4.59-3.17-7.58v-20.99
c-7.58,8.47-16.76,15.7-27.34,21.87c-10.58,6-22.22,9.17-34.57,9.17c-11.46,0-22.22-2.11-32.1-6.17
c-10.05-4.06-18.69-9.88-26.28-17.1c-7.58-7.41-13.57-16.05-17.81-26.1c-4.41-10.05-6.52-21.16-6.52-32.98
c0-11.46,2.12-22.22,6.35-32.1c4.23-10.05,10.05-18.69,17.46-26.1c7.41-7.41,16.23-13.41,26.46-17.81
C431.51,393.22,442.62,390.75,454.43,390.22 M392.18,473.82c0,8.47,1.59,16.4,4.76,23.99c3.17,7.41,7.58,13.93,13.23,19.57
c5.65,5.65,12.17,10.05,19.57,13.23c7.41,3.17,15.35,4.76,23.81,4.76c8.29,0,16.05-1.59,23.45-4.58
c7.41-3.17,13.76-7.41,19.4-12.88c5.65-5.47,10.05-12,13.41-19.4c3.35-7.41,5.29-15.7,5.65-24.52c0-8.46-1.59-16.58-4.76-23.98
c-3.18-7.58-7.59-14.11-13.23-19.75c-5.64-5.64-12.17-10.05-19.75-13.23c-7.59-3.17-15.52-4.76-24.16-4.76
c-8.46,0-16.4,1.59-23.81,4.76c-7.41,3.17-13.93,7.59-19.57,13.23c-5.65,5.65-10.05,12.18-13.23,19.75
C393.77,457.24,392.18,465.35,392.18,473.82"
      />
      <path
        class="st0"
        d="M577.19,545.95c0,3-1.06,5.47-3.17,7.59c-2.12,2.11-4.59,3.17-7.58,3.17c-3,0-5.47-1.05-7.59-3.17
c-2.12-2.12-3.17-4.59-3.17-7.59V346.49c0-3,1.06-5.47,3.17-7.59c2.12-2.12,4.59-3.17,7.59-3.17c2.99,0,5.46,1.06,7.58,3.17
c2.12,2.11,3.17,4.59,3.17,7.59V462l70.54-69.13c2.12-2.12,4.59-3.17,7.59-3.17c2.99,0,5.46,1.06,7.58,3.17
c2.12,2.12,3.17,4.58,3.17,7.58c0,3-1.06,5.47-3.17,7.59l-50.61,48.14l52.56,84.66c1.59,2.46,1.94,5.11,1.23,7.94
c-0.88,2.82-2.47,4.94-4.94,6.52c-2.47,1.59-5.12,1.94-7.94,1.24c-2.83-0.89-4.94-2.47-6.53-4.95l-49.91-79.72l-19.57,19.57V545.95
z"
      />
      <path
        class="st0"
        d="M698.35,400.27c0-3,1.06-5.46,3.17-7.58c2.12-2.11,4.59-3.17,7.58-3.17c3,0,5.47,1.06,7.59,3.17
c2.12,2.12,3.17,4.58,3.17,7.58v145.86c0,2.99-1.06,5.47-3.17,7.58c-2.12,2.11-4.59,3.17-7.59,3.17c-2.99,0-5.46-1.06-7.58-3.17
c-2.12-2.12-3.17-4.59-3.17-7.58V400.27z"
      />
      <path
        class="st0"
        d="M821.8,390.22c10.94,0,21.52,2.29,31.39,6.7c10.05,4.41,18.7,10.41,26.28,17.99
c7.59,7.58,13.58,16.41,17.99,26.45c4.41,10.06,6.7,20.81,6.7,32.28c0,11.28-2.12,21.87-6.52,31.74
c-4.41,10.05-10.23,18.7-17.64,26.28c-7.41,7.58-16.23,13.58-26.28,17.81c-10.05,4.41-20.99,6.53-32.63,6.53
c-11.47,0-22.22-2.12-32.1-6.17c-10.05-4.06-18.7-9.88-26.28-17.11c-7.58-7.41-13.58-16.05-17.81-26.1
c-4.41-10.05-6.52-21.17-6.52-32.98V346.48c0-3,1.06-5.47,3.17-7.58c2.12-2.12,4.58-3.17,7.58-3.17c3,0,5.47,1.05,7.59,3.17
c2.12,2.11,3.17,4.58,3.17,7.58v74.96c7.58-8.29,16.57-15.35,27.16-21.52C797.29,393.93,808.93,390.75,821.8,390.22 M759.55,473.82
c0,8.47,1.59,16.4,4.76,23.99c3.17,7.41,7.58,13.93,13.23,19.57c5.65,5.65,12.17,10.05,19.57,13.23
c7.41,3.17,15.35,4.76,23.81,4.76c8.46,0,16.57-1.59,23.98-4.76c7.59-3.17,14.11-7.58,19.76-13.23
c5.65-5.65,10.05-12.17,13.23-19.57c3.17-7.41,4.76-15.34,4.76-23.99c0-8.46-1.59-16.57-4.76-23.98
c-3.17-7.59-7.58-14.11-13.23-19.75c-5.65-5.65-12.17-10.05-19.76-13.23c-7.58-3.17-15.52-4.76-23.98-4.76
c-8.29,0-16.05,1.59-23.46,4.59c-7.41,3.17-13.76,7.4-19.22,12.87c-5.47,5.47-10.06,12-13.41,19.57
C761.66,456.54,759.9,464.82,759.55,473.82"
      />
      <path
        class="st0"
        d="M997.64,390.22c10.94,0,21.52,2.29,31.39,6.7c10.05,4.41,18.7,10.41,26.28,17.99
c7.59,7.58,13.58,16.41,17.99,26.45c4.41,10.06,6.7,20.81,6.7,32.28v72.49c0,2.99-1.06,5.47-3.17,7.58
c-2.12,2.12-4.59,3.17-7.58,3.17c-3,0-5.47-1.06-7.59-3.17c-2.12-2.11-3.17-4.59-3.17-7.58v-20.99
c-7.58,8.47-16.76,15.7-27.34,21.87c-10.58,6-22.22,9.17-34.57,9.17c-11.46,0-22.22-2.11-32.1-6.17
c-10.05-4.06-18.69-9.88-26.28-17.1c-7.58-7.41-13.57-16.05-17.81-26.1c-4.41-10.05-6.52-21.16-6.52-32.98
c0-11.46,2.12-22.22,6.35-32.1c4.23-10.05,10.05-18.69,17.46-26.1c7.41-7.41,16.23-13.41,26.46-17.81
C974.54,393.22,985.65,390.75,997.64,390.22 M935.38,473.82c0,8.47,1.59,16.4,4.76,23.99c3.17,7.41,7.58,13.93,13.23,19.57
c5.65,5.65,12.17,10.05,19.57,13.23c7.41,3.17,15.35,4.76,23.81,4.76c8.29,0,16.05-1.59,23.45-4.58
c7.41-3.17,13.76-7.41,19.4-12.88c5.65-5.47,10.05-12,13.41-19.4c3.35-7.41,5.29-15.7,5.65-24.52c0-8.46-1.59-16.58-4.76-23.98
c-3.18-7.58-7.59-14.11-13.23-19.75c-5.64-5.64-12.17-10.05-19.75-13.23c-7.59-3.17-15.52-4.76-23.99-4.76
c-8.46,0-16.4,1.59-23.81,4.76c-7.41,3.17-13.94,7.59-19.57,13.23c-5.65,5.65-10.06,12.18-13.23,19.75
C936.97,457.24,935.38,465.35,935.38,473.82"
      />
    </g>
  </svg>
</div>
